module.exports = __webpack_public_path__ + "static/media/04-park.1a9db3b4.png";